import React, { Component } from 'react'
import Pagelayout from "../pagelayout"
import TopupList from './topuplist';
import Tabs from '../Orders/tabs';

const tabs = [
    {
        name: "Recharge",
        component: <TopupList is_recharge={true} />
    },
    {
        name: "Top Up",
        component: <TopupList is_recharge={false} />
    }
];

class Packagelist extends Component {
    render() {
        return (
            <Pagelayout pad={true} fullWidth>
                <Tabs tabs={tabs} />
            </Pagelayout>
        )
    }
}

export default Packagelist
